<template>
        <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
                <div class="header-body">
                    <div class="row align-items-center py-4">
                        <div class="col-lg-6 col-md-12 mb-4">
                            <h2>Do Not Bid</h2>
                        </div>
                        <div class="col-lg-6 col-md-12 col-10 text-right bid">
                            <div class="input-group d-inline-flex justify-content-end">
                                <form @submit.prevent="" class="d-inline-block justify-content-center headSearch mr-2">
                                    <i @click="search()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                                    <input v-on:keyup.enter="search" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm" type="text" placeholder="Search cusip" aria-label="Search">
                                    <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
        <div class="container-fluid mt--6 filter-show">
            <div class="card w-100 p-2 mb-2  d-inline-block">
            <div class="row">
              <div class="col-lg-6">
                <form class="row" @submit.prevent="">
                    <div class="col-md-2 col-lg-9">
                      <label for="filter" class="col-form-label">CUSIP</label>
                      <input max="9" v-model="searchVal" v-on:keyup.enter="getCusipList" class="form-control" placeholder=""/>
                    </div>
                    <div class="col-md-3 mt-2 tbl-sch col-lg-3 input-group" style="top: 36px">
                        <button :disabled="loading" @click="getCusipList()" type="button" class="btn btn-success rounded arbs-btn">
                            <i  class="fas fa-plus"></i>
                            ADD 
                        </button>
                    </div>
                </form>
              </div>
            </div>
          </div>
        </div>
    </div>   
    
    <div class="container-fluid" >
        <div class="row">
            <div class="col-xl-12">
                <div class="card vh-75" id="scroll">
                    <div class="table-responsive">
                        <div v-if="loading" class="loader">
                            <img src="@/assets/img/loader.svg" alt="" />
                        </div>
                    <table
                        class="table align-items-center table-flush table-hover bidtbl"
                        style="min-height: 125px"
                    >
                        <thead class="thead-light psticky">
                        <tr>
                            <th scope="col" class="sort text-center">CUSIP</th>
                            <th scope="col" class="sort text-center">ACTION</th>
                        </tr>
                        </thead>
                        <tbody class="list no-cursor">
                        <tr v-if="notBidList.length == 0">
                            <td><p class="nodata">No data available</p></td>
                        </tr>
                        <tr v-for="data in notBidList" :key="data.id">
                            <td class="text-center">{{ data}}</td>
                            <td class="text-center">
                                <button @click="removeCusipFromList(data)" class="btn btn-danger" type="button">
                                    <i class="fas fa-trash"></i>
                                  </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
            </div>
        </div>
     </div> 
    
    </div>  
                  
     
</template>
<script>
import config from "@/config";
import authService from "@/authService";
export default {
  name: "imsCusipComponent",
  components : {
    
    
  },
  data() {
    return {
        loading : false,
        searchVal : "",
        cusipData : null,
        supportDataModalOpen : false,
        notBidList : [],
        searchValue : null
    };
  },
  methods: {
    getCusipList() {
        if (!this.searchVal) {
            this.$alert("Cusip is required.","","error");
            return false;
        }
        if (this.searchVal.length != 9) {
            this.$alert("Enter 9 digit characters long  CUSIP","","error");
            return false;
        }
        if (this.notBidList.includes(this.searchVal)) {
            this.$alert("CUSIP Already added","","error");
            return false;
        }
        this.addCusipToList(this.searchVal)
        // this.loading = true;
        // const auth = {
        //     headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
        // };
        // this.$http
        //     .get(
        //     config.baseUrlBidSide +
        //         "/cusip/list?page=1&size=10&cusip="+this.searchVal +"&status=ACTIVE,BLOCKED&sortColumn=cusip&sortOrder=ASC&type=BID",
        //         auth
        //     )
        //     .then(result => {
        //         this.loading = false;
        //         if(result.data.content.length == 0){
        //             this.$alert("No result found","","warning");
        //             this.supportDataModalOpen = false;
        //             this.cusipData = null;
        //             return false;
        //         }
        //         if(result.data.content[0].status  == "BLOCKED"){
        //           this.$alert("This CUSIP is blocked","","warning");
        //           this.supportDataModalOpen = false;
        //           this.cusipData = null;
        //           return false;
        //         }
        //         this.cusipData = result.data.content[0];
        //         this.addCusipToList(this.cusipData.cusip)
        //     })
        //     .catch(e => {
        //         console.log("Error", e);
        //     });
    },
    addCusipToList(cusip){
        this.loading = true;
        const auth = {
            headers: {'org-token' : authService.getOrgToken() }
        };
        let data = {"userId":authService.getUser().id,"cusip":cusip}
        this.$http
            .post(
            config.baseUrlAutoBidder +
                "/autobidder/nobid-add",data,
                auth
            )
            .then(() => {
                this.loading = false; 
                this.searchVal = "";
                this.getNotBidList();
                this.$alert("CUSIP Added to do not bid list","","success");
            })
            
    },
    getNotBidList() {
        this.loading = true;
        const auth = {
            headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
        };
        this.$http
            .get(
            config.baseUrlAutoBidder +
                "/autobidder/nobid/"+authService.getUser().id,
                auth
            )
            .then(result => {
                this.loading = false;
                this.notBidList = [];
                if(result.data.length){
                    if(result.data[0].cusips){
                        this.notBidList = result.data[0].cusips
                    }else{
                        this.notBidList = [];                    
                    }
                }
            })
            .catch(e => {
            console.log("Error", e);
            //self.loading = false;
            });
    },
    removeCusipFromList(cusip){
        this.loading = true;
        const auth = {
            headers: {'org-token' : authService.getOrgToken() }
        };
        let data = {"userId":authService.getUser().id,"cusip":cusip}
        this.$http
            .post(
            config.baseUrlAutoBidder +
                "/autobidder/nobid-remove",data,
                auth
            )
            .then(() => {
                this.loading = false; 
                this.searchVal = "";
                this.getNotBidList();
                this.$alert("CUSIP Removed from do not bid list","","success");
            })
            
    },
  },
  mounted() {
    this.getNotBidList();
  }
};
</script>
<style scoped>
.no-data {
  color: #8898aa!important;
}
.no-results-found {
  position: absolute;
  right: 50%;
  top: 50%;
}
</style>